import { Controller, FieldErrors } from "react-hook-form";
import CustomSelect from "../../CustomSelect";
import "./style.css";

interface IProps {
  name: string;
  control: any;
  options: { label: string; value: string }[];
  className?: string;
  containerClassName?: string;
  label: string;
  showClear?: boolean;
  showSearch?: boolean;
  error?: string | FieldErrors;
  disabled?: boolean;
  loading?: boolean;
  onCustomChange?: (val?: string | string[]) => void;
  isRequired?: boolean;
}

const ControlledSelect = ({
  name,
  control,
  options,
  className = "",
  containerClassName = "",
  label,
  showClear,
  showSearch,
  error,
  disabled,
  loading,
  onCustomChange,
  isRequired,
}: IProps) => {
  const getErrorMessage = (): string | undefined => {
    if (!error) return undefined;

    if (typeof error === "string") {
      return error;
    }

    // Navega pela estrutura aninhada de erros usando o caminho do name
    // Ex: "address.street" -> error.address.street
    if (typeof error === "object") {
      const nameParts = name.split(".");
      let currentError: any = error;

      for (const part of nameParts) {
        if (currentError && typeof currentError === "object" && part in currentError) {
          currentError = currentError[part];
        } else {
          return undefined;
        }
      }

      return currentError?.message as string | undefined;
    }

    return undefined;
  };

  const errorMessage = getErrorMessage();

  return (
    <div className={`controlled-select-container ${containerClassName || ""}`}>
      <label htmlFor={name} className={`controlled-select-label ${errorMessage ? "error" : ""}`}>
        {label}
        {isRequired && <span className="input-text-required"> *</span>}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <CustomSelect
            value={value}
            onChange={(val) => {
              onChange(val);
              onCustomChange && onCustomChange(val);
            }}
            options={options}
            showClear={showClear}
            showSearch={showSearch}
            className={`controlled-select-input ${className || ""} ${errorMessage ? "error" : ""}`}
            disabled={disabled || loading}
          />
        )}
      />
      {errorMessage && <small className="controlled-select-error">{errorMessage}</small>}
    </div>
  );
};

export default ControlledSelect;
